<template>
  <div class="">
    <el-main>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="x-per-lebg">讲师库
              <!-- <div class="x-person-name" @click="allperson">{{company}}</div> -->
            </div>
            <ul style="height:460px;overflow-y:auto;">
              <li class="x-per-li" v-if="teacherdata != ''" v-for="item in teacherdata" :key="item.key" @click="openteachertoast(item.id,item.username)">
                <div class="x-teac-l">
                  <img :src="item.avatar" alt="">{{item.username}}
                </div>
                <div class="x-teac-r">
                  <el-button type="text" class="x-perli-item" @click.stop="teacheredit(item)" style="color:#BDA17A">编辑</el-button>
                  <el-button type="text" class="x-perli-item x-font-danger" @click.stop="teacherremove(item.id,item.username)">删除</el-button>
                </div>

              </li>
              <div class="x-nothing" v-else>还没有讲师哦</div>
              <div class="x-btn x-btn-bl x-person-btn" @click="addteacher"><span class="x-ac-addbtn"></span>添加讲师</div>
            </ul>
          </div>
        </el-col>
        <el-col :span="18">
          <!--  -->
          <div class="x-study-all">
            <!-- 按钮组 -->
            <div class="x-all-btn">
              <div class="x-btn-left">
                <div class="x-btn-right">
                  <el-button type="" class="x-btn x-btn-bl x-class-ad" @click="handleAdd" style="line-height: inherit;">
                    <i class="layui-icon x-left-span x-left-span1"></i>课程分类管理
                  </el-button>
                  <router-link to="/index/uploadclass" class="x-btn x-btn-bl x-class-ad">
                    <i class="layui-icon x-left-span x-left-span2"></i>添加课程
                  </router-link>
                </div>
                <el-tabs v-model="activeName" class="x-pro-tab1">
                  <el-tab-pane label="企业课程" name="first">
                    <el-tabs v-model="activeNameTwo" type="card" @tab-click="handleClick" v-if="showclasslist != ''" v-loading="allmainproloading">
                      <el-tab-pane :label="item.title" :name="index.toString()" v-for="(item,index) in showclasslist" :key="item.id" :value="item.id">
                        <ul class="x-main-ul">
                          <div class="" v-if="classlistli.length != 0">
                            <li v-for="(item,index) in classlistli" :key="item.key">
                              <el-image class="x-main-img" :src="item.cover"></el-image>
                              <div class="x-main-text">{{item.title}}</div>
                              <div class="x-main-btngroup">
                                <span class="x-btn x-main-btn1" @click="editclassli(classlistli[index],'1')">编辑</span>
                                <span class="x-btn x-main-btn2" @click="removeclassli(item.id,item.title)">删除</span>
                                <!-- <span class="x-btn x-main-btn3">取消发布</span> -->
                              </div>
                            </li>
                        </div>
                        <div class="x-noclass-desc" v-else>
                          还没有课程哦
                        </div>
                        </ul>
                      </el-tab-pane>
                    </el-tabs>
                    <el-tabs v-if="showclasslist == ''">请先添加课程分类</el-tabs>
                  </el-tab-pane>
                  <el-tab-pane label="读书会" name="second">
                    <div class="x-plase-hold">敬请期待</div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

    </el-main>
    <!--  -->
    <!--新增界面-->
		<el-dialog title="课程分类管理" :visible.sync="addFormVisible" width="66%">
      <div class="x-addclass-box">
      	<div class="x-addclass-inputbox">
          <el-input v-model="addcll" placeholder="请输入内容" size="large" style="margin:0;"></el-input>
          <div class="x-desc" v-show="desc">请输入活动名称</div>
      		<div class="x-btn x-btn-bl x-add-btn" @click="newclassye" v-loading="addclassloading"><span class="x-ac-modyfy"></span>新增分类</div>
      	</div>
      	<div class="x-addclass-listbox">
      		<ul class="no-margin">
      			<li class="" v-for="item in showclasslist" :key="item.key">
      				<div class="x-ac-text">
      					<span v-show="modifytitle!=item.id" class="x-modify-span" :data-span="item.id">{{item.title}}</span>
                <div v-show="modifyinput==item.id">
                  <el-input placeholder="请输入内容" size="small" v-model="modifyok" class="x-modify-k"></el-input>
                  <div class="x-desc" v-show="desctwo">请输入活动名称</div>
                  <el-button type="text" @click="okgomodify(item.id)">确定修改</el-button>
                  <el-button type="text" @click="nogomodify(item.id)">取消修改</el-button>
                </div>
      				</div>
      				<div class="x-ac-btnbox">
      					<span class="x-ac-modyfy" @click="modifyclalist(item.id)">修改</span>
      					<span class="x-ac-remove" @click="removeclalist(item.id,item.title)">删除</span>
    					</div>
      			</li>
      		</ul>
      	</div>
      </div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addFormVisible = false">确认</el-button>
			</div>
		</el-dialog>
    <!--添加讲师弹窗-->
    <el-dialog :title="teachertitle" :visible.sync="addteachertoast" class="x-addb-hed">
      <div class="x-addclass-box">
        <el-form ref="teacherform" :model="teacherform" label-width="80px" :rules="rules">
          <el-form-item label="讲师名称">
            <el-input v-model="teacherform.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="上传头像">
            <el-upload
              class="upload-demo x-teacher-head"
              action="http://peixun.dlbbdk.com/upload/oss"
              :on-preview="handlePreview"
              :on-success="headsucc"
              multiple
              :limit="1"
              :show-file-list="false"
              :file-list="headfileList">
              <!-- <img :src="teacherhead" alt="" style="width:60px;height:60px;border-radius:50%;"> -->
              <el-button size="small" type="primary">点击上传</el-button>
              <div :style="{'background-image':'url('+teacherhead+')','width':'60px','height':'60px','border-radius':'50%','display':'inline-block','vertical-align':'middle','margin-right':'14px'}" class="x-teacher-class">

              </div>
              <div slot="tip" class="el-upload__tip">建议文件尺寸150*150</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="讲师简介">
            <el-input type="textarea" :rows="5" v-model="teacherform.textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl" @click="addteacherbtn('teacherform')" v-if="teacherbtnok">添加</div>
        <div class="x-btn x-btn-bl" @click="changeteacher" v-if="teacherbtnno">修改</div>
      </div>
    </el-dialog>
    <!-- 查看讲师详情 -->
    <el-dialog :title="teacherdesctitle" :visible.sync="teacherdesctoast">
      <el-table :data="teacherdescdata">
        <el-table-column property="date" label="课程标题" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column property="date" label="亲和力" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.friendly_score }}</span>
          </template>
        </el-table-column>
        <el-table-column property="name" label="表达力" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.desc_score }}</span>
          </template>
        </el-table-column>
        <el-table-column property="address" label="课程结构">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.course_score }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'mainpro',
  data () {
    return {
        phone:localStorage.phone,
        company:localStorage.company,
        token:'',
        user_id:'',
        input:'',
        addFormVisible: false,//新增界面是否显示
        addcll:'',
        desc:false,//input验证
        showclasslist:'',
        activeName: 'first',
        activeNameTwo: '0',
        addclassloading:false,
        modifytitle:true,
        modifyinput:false,
        modifyok:'',
        desctwo:'',
        allmainproloading:true,
        classlistli:'',//课程
        tabindex:'0',
        videonum:'0',
        teacherdata:'',
        addteachertoast:false,
        teacherform:{
          name:'',
          textarea:''
        },
        rules:{
          name:[
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 2, max: 4, message: '长度在 2 到 4 个字符', trigger: 'blur' }
          ],
          textarea:[
            { required: true, message: '请填写讲师简介', trigger: 'blur' }
          ]
        },
        headfileList:[],
        teacherhead:'',
        teachertitle:'添加讲师',
        teacherbtnok:false,
        teacherbtnno:false,
        teacherid:'',
        teacherdescid:'',
        teacherdesctitle:'',
        teacherdesctoast:false,
        teacherdescdata:[]
    }
  },
  created() {
    this.allmainproloading = true;
    this.classlist();
    this.teacherda();//讲师列表
  },
  mounted() {


  },
  methods:{
    //
    openteachertoast:function(id,title){
      this.teacherdescid = id;
      this.teacherdesctitle = title + '老师的课程列表';
      this.teacherdesctoast = true;
      axios.get('/admin/lecturer/courseList', {
        params: {
          sec: localStorage.token,
          id:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.teacherdescdata = response.data.data;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //讲师头像上传
    headsucc:function(response, file, fileList){
      console.log(response.data[0].url);
      this.teacherhead = response.data[0].url;
    },
    handlePreview:function(){

    },
    //讲师列表
    teacherda:function(){
      axios.get('/admin/lecturer/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.teacherdata = response.data.data;
        }else{
          this.allmainproloading = false
          console.log('失败');
          this.$router.push({name:'Login'});
          localStorage.token = '';
          console.log(localStorage.token);
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //添加讲师
    addteacher:function(){
      this.teacherform.name = '';
      this.teacherhead = '';
      this.teacherform.textarea = '';
      this.addteachertoast = true;
      this.teachertitle = '添加讲师';
      this.teacherbtnok = true;
      this.teacherbtnno = false;
    },
    //添加讲师2
    addteacherbtn:function(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证通过
          console.log(this.teacherform.name);
          console.log(this.teacherhead);
          console.log(this.teacherform.textarea);
          axios.get('/admin/lecturer/add', {
            params: {
              sec: localStorage.token,
              username:this.teacherform.name,
              avatar:this.teacherhead,
              content:this.teacherform.textarea
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
                this.addteachertoast = false;
                this.$message({
                  showClose: true,
                  message: '添加成员成功',
                  type: 'success'
                });
                //加载人员列表
                this.teacherda()
                // this.classlist()// 加载部门列表
                // 清空表单数据
                this.teacherform.name = '';
                this.teacherhead = '';
                this.teacherform.textarea = '';
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //编辑讲师
    teacheredit:function(val){
      console.log(val);
      this.addteachertoast = true;
      this.teachertitle = '编辑讲师';
      this.teacherbtnno = true;
      this.teacherbtnok = false;
      this.teacherform.name = val.username;
      this.teacherhead = val.avatar;
      this.teacherform.textarea = val.content;
      this.teacherid = val.id;
    },
    //编辑讲师2
    changeteacher:function(){
      axios.get('/admin/lecturer/edit', {
        params: {
          sec: localStorage.token,
          id:this.teacherid,
          username:this.teacherform.name,
          avatar:this.teacherhead,
          content:this.teacherform.textarea
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.addteachertoast = false;
            this.$message({
              showClose: true,
              message: '修改讲师成功',
              type: 'success'
            });
            //加载人员列表
            this.teacherda()
            // this.classlist()// 加载部门列表
            // 清空表单数据
            this.teacherform.name = '';
            this.teacherhead = '';
            this.teacherform.textarea = '';
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //删除讲师
    teacherremove:function(id,title){
      this.$confirm('是否删除"'+title+'"讲师?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/lecturer/del', {
            params: {
              sec: localStorage.token,
              id:id
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.teacherda()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // 课程分类列表
    classlist(){
      axios.get('/admin/cate/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.allmainproloading = false
            console.log(response.data.data);
            this.showclasslist = response.data.data;
            this.classlistlidata()
        }else{
          this.allmainproloading = false
          console.log('失败');
          this.$router.push({name:'Login'});
          localStorage.token = '';
          console.log(localStorage.token);
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //显示新增界面
		handleAdd() {
			this.addFormVisible = true;
		},
    // 添加课程分类
    newclassye(){
      if(this.addcll == ''){
        this.desc = true;
      }else{
        this.desc = false;
        this.addclassloading=true;
        axios.get('/admin/cate/add', {
          params: {
            sec: localStorage.token,
            title:this.addcll
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            this.addclassloading = false;
              this.addcll = ''
              this.$message({
                showClose: true,
                message: '添加分类成功',
                type: 'success'
              });
              this.classlist()//课程分类列表
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 删除课程分类
    removeclalist(classid,title){
      console.log(classid);
      this.$confirm('是否删除"'+title+'"课程分类?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/cate/del', {
            params: {
              sec: localStorage.token,
              id:classid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.classlist()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // 确定修改
    okgomodify(classid){
      if(this.modifyok == ''){
        this.desctwo = true;
      }else{
        this.desctwo = false;
        this.addclassloading=true;
        axios.get('/admin/cate/edit', {
          params: {
            sec: localStorage.token,
            title:this.modifyok,
            id:classid
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            this.addclassloading = false;
              // this.addcll = ''
              this.modifytitle = ''
              this.modifyinput = ''
              this.$message({
                showClose: true,
                message: '添加分类成功',
                type: 'success'
              });
              this.classlist()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 切换修改输入框
    modifyclalist(classid){
      this.modifytitle = classid
      this.modifyinput = classid
    },
    // 选项卡
    handleClick(tab, event) {
      let id = event.target.getAttribute('id').split('-');
      this.tabindex = id.join('').substring(3,5)
      console.log(this.tabindex);
      this.classlistlidata()
    },
    // 课程展示
    classlistlidata(){
      console.log(this.tabindex);
      console.log(this.showclasslist[this.tabindex].id);
      let classlistid = this.showclasslist[this.tabindex].id
      axios.get('/admin/course/list', {
        params: {
          sec: localStorage.token,
          cateId:classlistid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.classlistli = response.data.data;
            this.videonum = response.data.data.course_count;
            this.allmainproloading = false
        }else{
          this.allmainproloading = false;
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 删除课程
    removeclassli(id,title){
      this.$confirm('确定要删除"'+title+'"课程吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/course/del', {
            params: {
              sec: localStorage.token,
              id:id
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.classlistlidata()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // 取消修改课程分类
    nogomodify(){
      this.modifytitle = ''
      this.modifyinput = ''
      this.desctwo = false;
    },
    // 编辑课程
    editclassli(classdata,isedit){
      console.log(classdata);
      console.log(isedit);
      this.$router.push({
        name:'uploadclass',
        params:{
          classdata:classdata,
          isedit:isedit
        }
      });
    }
  }
}
</script>

<style scoped>
.x-study-pro {
  box-shadow: 4px 4px 10px 0px rgba(218,218,218,0.5);
  background-color: #F5F5F5;
  overflow: hidden;
}.x-pro-left {
  width: 243px;
  height: 113px;
  background: -webkit-linear-gradient(226deg, rgba(30,175,246,1) 0%, rgba(128,209,254,1) 100%);
  background: -o-linear-gradient(226deg, rgba(30,175,246,1) 0%, rgba(128,209,254,1) 100%);
  background: linear-gradient(316deg, rgba(30,175,246,1) 0%, rgba(128,209,254,1) 100%);
  position: absolute;
}.x-pro-right {
  margin-left: 243px;
  height: 113px;
  padding: 25px 20px;
  position: relative;
  box-sizing: border-box;
  text-align: left;
}.x-pro-t {
  color: #3F3F3F;
  font-size: 20px;
}.x-pro-desc {
  color: #A6A6A6;
  font-size: 12px;
  margin-top: 12px;
}.x-pro-num {
  position: absolute;
  top: 50%;
  right: 20px;
  font-size: 20px;
  margin-top: -16px;
}.x-pro-num span {
  color: #FF4D4D;
}*{
  /* overflow: hidden; */
}
/* 搜索 */
.x-study-all {
    margin: 0;
}.x-all-title {
    position: relative;
    border-bottom: 1px solid #eee;
    padding: 10px 0 30px 0;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
}.x-all-search {
    display: flex;
    align-items: center;
    justify-content: inherit;
}.x-all-search .x-search-input .el-input__inner{
    width: 500px;
    border: 0;
    background-color: #ECECEC;
    margin-right: 10px;
    font-size: 14px;
}.x-btn {
    background-color: #BDA17A;
    font-size: 14px;
    color: #fff;
    text-align: center;
    height: 44px;
    line-height: 44px;
    width: 126px;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    margin-right: 0;
    margin-left: 10px;
}.x-search-icon {
    background: url(../images/search.png)no-repeat;
    background-size: contain;
    width: 16px;
    margin-right: 8px;
    display: inline-block;
    line-height: 16px;
    height: 16px;
    vertical-align: text-bottom;
}
/* 按钮组 */
.x-all-btn {
    margin: 0;
    overflow: hidden;
}.x-btn-left {
    position: relative;
    padding-top: 0;
    width: 100%;
    padding: 0!important;
}.x-btn-right {
    display: block;
    text-align: left;
    margin-bottom: 1rem;
}.x-btn-noblue {
    border: 1px solid #BDA17A;
    background-color: #fff;
    color: #BDA17A;
}.x-btn-bl, .x-btn-bl2 {
    background: #BDA17A;
    text-decoration: none;
}.x-btn-bl:hover{
    text-decoration: none;
}
.x-btn:hover {
    opacity: .7;
    color: #fff;
}.x-addclass-inputbox{
  display: flex;
}.x-addclass-inputbox{
  line-height: 44px;
  height: 44px;
  margin-right: 16px;
  position: relative;
  padding-bottom: 15px;
}.x-addclass-listbox {
    margin: 5px;
    max-height: 390px;
    overflow-y: scroll;
}.x-addclass-listbox li {
    color: #BDA17A;
    cursor: pointer;
    text-align: left;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}.x-ac-text {
  display: flex;
  position: relative;
}.x-ac-btnbox {
    line-height: 32px;
    height: 32px;
}.x-ac-modyfy, .x-ac-remove {
    background: url(../images/change.png)no-repeat;
    background-size: contain;
    width: 14px;
    height: 14px;
    vertical-align: bottom;
    padding-left: 25px;
    margin-right: 0px;
    display: initial;
}.x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
}.x-add-btn .x-ac-modyfy {
    background: url(../images/add.png)no-repeat;
    background-size: contain;
    margin-right: 10px;
    width: 10px;
    height: 10px;
}.x-add-btn {
    width: 200px;
   margin-left: 20px;
}.no-margin{
  padding-left: 0;
  margin-bottom: 0;
}.x-desc{
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  left: 0px;
  bottom: 0;
}.x-modify-span{
  line-height: 32px;
  height: 32px;
  display: inline-block;
}.x-modify-k{
  width: 200px;
  margin-right: 10px;
}.x-class-ad{
  line-height: 44px;
  height: 44px;
  margin:0 32px 0 0;
  border: 0;
  vertical-align: top;
  width: 190px;
}.el-main{
  overflow: inherit;
}ul,li{
  list-style: none;
}.x-main-ul {
  position: relative;
}.x-main-ul li {
  border-bottom: 1px solid #DDDDDD;
  cursor: pointer;
  position: relative;
  text-align: left;
}.x-main-img {
  width: 200px;
  height: 130px;
  position: absolute;
  margin-top: 25px;
}.x-main-text {
  padding-left: 230px;
  color: #3F3F3F;
  font-size: 16px;
  line-height: 180px;
  height: 180px;
}.x-main-btngroup {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -22px;
}.x-main-btn2 {
  background: #fff;
  border: 1px solid #779690;
  color: #779690;
}.x-main-btn1:hover{
  background: #BDA17A;
  border: 1px solid #BDA17A;
  color: #fff;
}.x-main-btn2:hover{
  background: #779690;
  border: 1px solid #779690;
  color: #fff;
}
.x-main-btn3 {
  margin-right: 0;
  background-color: #AF6D1A;
}.x-noclass-desc{
  color: #ccc;
  font-size: 16px;
  padding-top: 40px;
}.x-left-span {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
}.x-left-span1 {
    background: url(../images/class1.png)no-repeat;
    background-size: contain;
}.x-left-span2 {
    background: url(../images/class2.png)no-repeat;
    background-size: contain;
}.x-main-btn1{
  background: #fff;
  border: 1px solid #BDA17A;
  color: #BDA17A;
}.x-teac-l img{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  vertical-align: bottom;
}.x-teac-l{
  align-self: center;
  font-size: 14px;
}.x-per-lebg{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 30px;
  line-height: 30px;
}.x-teacher-head{
  text-align: left;
}.x-teacher-class{
  background-size: cover;
}
</style>
<style media="screen">
.x-search-input .el-input__inner{
  width: 500px;
    border: 0;
    background-color: #ECECEC;
    margin-right: 10px;
    font-size: 14px;
    height: 44px;
    line-height: 44px;
}.el-dialog__header{
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}.el-input--small .el-input__inner{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/mainpro.vue